module.exports = __webpack_public_path__ + "assets/img/consideration-couts-qualitatifs-quantitatifs.5bfa584f.jpg";